<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <DeductionsPlanForm
      v-if="!isLoading"
      :deductionsPlanData="deductionsPlanData"
      :submitName="$t('edit')"
      v-on:addOrUpdateDeductionsPlan="updateDeductionsPlan()"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import DeductionsPlanForm from "@/components/settings/settingsSalary/deductionsPlans/DeductionsPlanForm.vue";
import DeductionsPlan from "@/models/settings/settingsSalary/deductionsPlans/DeductionsPlan";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "DeductionsPlanEdit",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    DeductionsPlanForm,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      deductionsPlanData: new DeductionsPlan(),
      deductionsPlansToken: this.$route.params.deductionsPlansToken,
    };
  },
  methods: {
    async getDeductionsPlanDetails() {
      this.isLoading = true;
      this.deductionsPlanData.deductionsPlansToken = this.deductionsPlansToken;
      try {
        let response = await this.deductionsPlanData.getDeductionsPlanDetails(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.deductionsPlanData.fillData(response.data.deductionsPlansData);
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
          this.deductionsPlanData = null;
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.deductionsPlanData = null;
      }
      this.isLoading = false;
    },
    async updateDeductionsPlan() {
      this.isLoading = true;
      try {
        let response = await this.deductionsPlanData.addOrUpdateDeductionsPlan(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$router.push("/deductions-plans/");
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.getDeductionsPlanDetails();
  },
};
</script>

<style scoped lang="scss"></style>
